import { Outlet } from 'react-router-dom';

import useBem from '@indicia/use-bem';

import DashboardNavigationLinks from '../../shared/components/header/navigation/dashboardNavigation/DashboardNavigation';
import useResultContext from './store/UseResultContext';

import './DashboardLayout.scss';

const DashboardLayout = () => {
  const { bemClassName } = useBem('dashboard-layout');
  const { result } = useResultContext();

  const hasResults = result.responseCode;

  return (
    <div className={bemClassName()}>
      {hasResults && (
        <aside className={bemClassName('sidebar')}>
          <DashboardNavigationLinks />
        </aside>
      )}
      <main className={bemClassName('content')}>
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
